import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import '@angular/common/locales/global/hu';
import { disableAutofillOnFieldsAndSetAutoselectText } from '@pct/browser';

disableAutofillOnFieldsAndSetAutoselectText();
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
